interface BookData {
	id: number;
	sku: string | null;
	title: string;
	description: string | null;
	format: string;
	language: string;
	slug: string;
	total_page: number;
	isbn: string | null;
	brand: string;
	educational_stage: string | null;
	duration_time: number;
	is_active: 0 | 1;
	is_bookmarked: 0 | 1;
	is_purchased: boolean;
	primary_price: number | null;
	price: number;
	discount_price: number | null;
	marketing_lowest_retail_price: number | null;
	commission_cut: number | null;
	shopee_url: string | null;
	tiktok_url: string | null;
	tokopedia_url: string | null;
	lazada_url: string | null;
	image_name: string | null;
	image_url: string | null;
	published_at: string;
	until_duration?: number;
	created_at: string;
	updated_at: string;
	images: {
		image_name: string;
		image_url: string;
	}[];
	BookWriter: BookWriter[];
	chapters: Chapter[];
	SubscriptionPlan: SubscriptionPlan[];
	BookPublisher: Publisher[];
	total_purchased: number;
	BookCategory: BookCategory[];
	minimum_print: number | null;
	primary_print_price: number | null;
	print_price: number | null;
	discount_print_price: number | null;
}

interface BookCategory {
	id: number;
	name: string;
}

interface Publisher {
	id: number;
	username: null;
	name: string;
	image_name: null;
	image_url: null;
	description: string;
	created_at: string;
	updated_at: string;
	pivot: {
		book_publisher_id: number;
		book_digital_id: number;
	};
}

interface SubscriptionPlan {
	id: number;
	name: string;
	description: string | null;
	duration_time: number;
	primary_price: number;
	price: number;
	discount_price: number;
	marketing_lowest_retail_price: number;
	created_at: string;
	updated_at: string;
	is_selected?: boolean;
	color: string | null;
	pivot: {
		subscription_plan_id: number;
		book_digital_id: number;
	};
}

interface Chapter {
	name: string;
	page_end: number;
	page_start: number;
	price: number;
	discount_price: number;
}

interface BookWriter {
	id: number;
	name: string;
	image_name: string | null;
	username: string | null;
	image_url: string | null;
	created_at: string;
	updated_at: string;
	pivot: {
		book_writer_id: number;
		book_digital_id: number;
	};
}

interface PromotionData {
	id: number;
	name: string;
	brand: string;
	book_digital_id: number | null;
	premium_bundle_id: number | null;
	image_name: string | null;
	image_url: string | null;
	redirect_url: string | null;
	is_active: 0 | 1;
	created_at: string;
	updated_at: string;
	Book: BookData[] | null;
	Bundle: BundleData | null;
}

interface Writer {
	id: number;
	name: string;
	image_name: string | null;
	image_url: string | null;
	created_at: string;
	updated_at: string;
	username: string;
	description: string;
}

type VerificationType = 'forgot-password' | 'register' | 'deactivate' | 'delete-account';

interface LoginDataResponse {
	id: number;
	id_number: string | null;
	name: string;
	email: string;
	google_email: string;
	phone: string;
	institution: string | null;
	program_study_exam_id: string | null;
	educational_stage: string | null;
	target_institution: string | null;
	target_occupation: string | null;
	semester: string | null;
	class_year: string | null;
	exam_date: string | null;
	google_id: string;
	brand: string;
	created_at: string;
	updated_at: string;
	token: {
		type: string;
		token: string;
		refreshToken: string;
		identifier: string;
	};
}

interface SearchItem {
	id: number;
	sku: string;
	title: string;
	description: string;
	slug: string;
	format: string;
	publisher: string;
	language: string;
	total_page: number;
	isbn: string;
	brand: string;
	duration_time: number;
	is_active: number;
	primary_price: number;
	price: number;
	discount_price: number;
	marketing_lowest_retail_price: null;
	commission_cut: number;
	image_name: null;
	image_url: null;
	published_at: string;
	created_at: string;
	updated_at: string;
	BookWriter: BookWriter[];
}

interface CategoryItem {
	id: number;
	name: string;
	total_books: number;
	value?: string;
	column_id?: string;
	slug?: string;
}

type CartItemBook = Pick<BookData, 'title' | 'slug' | 'id' | 'description'>;

interface CartItem extends CartItemBook {
	price: number;
	duration: number;
	primary_price: number;
	discount_price: number;
	marketing_lowest_retail_price: number;
	SubscriptionPlan: SubscriptionPlan[];
	book_writer: Writer[];
	image_name: string | null;
	image_url: string | null;
}

interface CartData {
	items: CartItem[];
	price: number;
	currency: string;
	member_id: number;
	totalItems: number;
	primaryPrice: number;
	discountPrice: number;
	marketingLowestPrice: number;
}

type PaymentStatus =
	| 'WAITING_FOR_PAYMENT'
	| 'COMPLETED'
	| 'PAYMENT_EXPIRED'
	| 'PAYMENT_FAILED'
	| 'CANCELED'
	| 'UPDATE_BUKTI_TRANSFER'
	| 'DP_COMPLETED'
	| 'LUNAS';

interface Transaction {
	id: number;
	order_no: string;
	status: PaymentStatus;
	price: number;
	book_list_id: number | null;
	premium_bundle_id: number | null;
	created_at: string;
	updated_at: string;
	book: BookData;
	premium_bundle: string | null;
}

type CenterNotifType = 'error' | 'success' | 'info';

interface BundleData {
	id: number;
	name: string;
	description: string | null;
	benefits: string[] | null;
	brand: string;
	primary_price: number | null;
	price: number;
	discount_price: number;
	marketing_lowest_retail_price: number | null;
	duration_time: number;
	is_active: number;
	image_name: string | null;
	image_url: string | null;
	created_at: string;
	updated_at: string;
	BookDigital: BookData[];
	SubscriptionPlan: SubscriptionPlan[];
	total_books: number;
}

interface DokuPaymentData {
	id: number;
	order_no: string;
	name: string;
	email: string;
	phone: string;
	price: number;
	doku_token: string;
	doku_url: string;
	updated_at: string;
}

interface CheckoutData {
	order_no: string;
	status: string;
	member_id: number;
	name: string;
	email: string;
	phone: string;
	jenjang_pendidikan: null;
	program_study_exam_id: null;
	semester: null;
	id_number: null;
	book_digital_id: number;
	duration_time: number;
	price: number;
	created_at: string;
	updated_at: string;
	id: number;
}

interface Rating {
	rating: Record<string, number>;
	percentage: Record<string, number>;
	average_rating: number | null;
	rating_participant: number;
	is_rated: boolean;
}

interface ReviewData {
	id: number;
	member_id: number;
	name: string;
	book_digital_id: number;
	rating: number;
	comment: string;
	is_show: 0 | 1;
	created_at: string;
	updated_at: string;
}

interface PanelItem {
	name: string;
	items: CategoryItem[];
	columnId: 'category_id' | 'writer_id' | 'publisher_id' | 'bundle_id' | 'other';
	isRenderMore: boolean;
	isOpened: boolean;
	isLoading: boolean;
	isDisabled?: boolean;
	apiPath: string;
}

interface InputAttrs {
	name: string;
	id: string;
	'data-fs-error': string | undefined;
	'aria-describedby': string | undefined;
	'aria-invalid': 'true' | undefined;
	'aria-required': 'true' | undefined;
	'data-fs-control': string;
}

interface SelectItem {
	label: string;
	value: string | number;
	price?: number;
	discount_price?: number;
}

interface ComboData {
	id: number;
	title?: string;
	name?: string;
	price?: string;
	discount_price?: string;
}

interface Chapter {
	id: number;
	name: string;
	manuscript_name: string;
	manuscript_url: string;
	manuscript_mime_type: string;
	writerAssigned?: number;
	has_order: 1 | 0;
}

interface DraftBookChapter extends Chapter {
	is_available: boolean;
}

interface DraftBookData {
	id: number;
	title: string;
	slug: string;
	uuid: string;
	image_name: string | null;
	image_url: string | null;
	remaining_chapters: number;
	total_chapters: number;
	chapters: DraftBookChapter[];
	price: number;
	available_chapters: Chapter[];
	minimum_print: number;
	primary_print_price: number;
	print_price: number;
	discount_print_price: number;
	includes_printed: 0 | 1;
}

export enum ReferralResponse {
	Valid = 'Referral valid',
	Invalid = 'Referral invalid',
	Expired = 'Referral expired',
	InvalidDate = 'Code has not reach start date yet',
	NotActivated = 'Code is not active',
	NotAccordance = 'The referral code cannot be used for this product',
	QuotaLimit = 'Reach the maximum quota'
}

type DynamicPanelItemColumnId = Exclude<PanelItem['columnId'], 'other'>;
type DynamicPanelItem = PanelItem & {
	columnId: DynamicPanelItemColumnId;
};

interface BookPublishingPlan {
	id: number;
	name: string;
	description: string | null;
	primary_price: number;
	price: number;
	dp_price: number | null;
	discount_price: number;
	primary_print_price: number;
	print_price: number;
	discount_print_price: number;
	minimum_print: number;
	minimum_writer: number;
	maximum_writer: number;
	image_name: string | null;
	image_url: string | null;
	is_collab: number;
	is_active: number;
	includes_printed: 0 | 1;
}

interface OrderData {
	name: string;
	email: string;
	phone: string;
	order_no: string;
	status: PaymentStatus;
	price: number;
	paid_at: string;
	draft_book_print_orders: {
		id: number;
		online_product_order_id: number;
		price: number;
		print_price: number;
		total_print: number;
		address: string | null;
	} | null;
	draft_book_orders: {
		id: number;
		draft_book_chapter: number;
		draft_book_id: number;
		name: string;
		price: number;
	}[];
	publishing_book: {
		id: number;
		title: string;
		price: number;
		is_printed: 0 | 1;
		total_print: number;
		total_print_price: number;
		online_product_order_id: number;
		address: string | null;
		Writer: {
			id: number;
			name: string;
			email: string;
			phone: string;
			university: string;
		}[];
	};
	book: {
		id: number;
		title: string;
	};
	book_digital_print_orders: {
		id: number;
		online_product_order_id: number;
		total_print: number;
		print_price: number;
		price: number;
		address: string;
	};
}

interface ConfirmationData {
	label: string;
	value?: string;
	items?: {
		label: string;
		value: string;
	}[];
}

interface AppDownloadLink {
	label: string;
	url: string;
	icon: string;
	transparent_icon: string;
	platform_key: 'Android' | 'Apple' | 'Windows';
}

export type {
	BookData,
	Chapter,
	BookWriter,
	VerificationType,
	SubscriptionPlan,
	PromotionData,
	Writer,
	LoginDataResponse,
	SearchItem,
	Publisher,
	CategoryItem,
	CenterNotifType,
	CartItem,
	CartData,
	Transaction,
	PaymentStatus,
	BundleData,
	CheckoutData,
	DokuPaymentData,
	Rating,
	ReviewData,
	PanelItem,
	InputAttrs,
	SelectItem,
	ComboData,
	DraftBookData,
	DynamicPanelItem,
	DynamicPanelItemColumnId,
	DraftBookChapter,
	BookPublishingPlan,
	OrderData,
	ConfirmationData,
	AppDownloadLink
};
